import React from 'react';
import { func, arrayOf, string, object } from 'prop-types';
import { searchState } from 'utils';
import { SortItem } from '../index';

export default function SortingList({
    className,
    currentRefinement,
    handleClick,
    groupedIndexes,
}) {
    return (
        <div className={className}>
            {groupedIndexes.map(({ value, label }) => (
                <SortItem
                    key={label}
                    className="sorting-root__item"
                    value={value}
                    label={label}
                    active={searchState.isRefined(value, currentRefinement)}
                    onClick={handleClick}
                />
            ))}
        </div>
    );
}

SortingList.propTypes = {
    className: string,
    currentRefinement: string.isRequired,
    handleClick: func.isRequired,
    groupedIndexes: arrayOf(object).isRequired,
};

SortingList.defaultProps = {
    className: null,
};
